
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayDigitalClosed as ObiThreewayDigitalClosedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-digital-closed.js';
 
 
 

 
 export const ObiThreewayDigitalClosed = createComponent({
   react: React,
   tagName: 'obi-threeway-digital-closed',
   elementClass: ObiThreewayDigitalClosedElement,
   events: {
     
   }
  });
 
 